export const IdTypes = [
  { label: 'South African', value: 'rsa_id' },
  { label: 'Zimbabwean', value: 'zim_id' },
  { label: 'Namibian', value: 'nam_id' },
  { label: 'Botswanan', value: 'bot_id' },
  { label: 'Other', value: 'oth_id' }
]